export default function dashboardSummaryDirective() {
  return {
    template: require('./dashboard-summary.html'),
    controller: 'DashboardSummaryController',
    controllerAs: 'dashboardSummaryVM',
    bindToController: true,
    replace: true,
  };
}
